import { useEffect, useState } from "react";

const links = [
  { href: "#home", label: "首页" },
  { href: "#board", label: "吃瓜广场" },
  { href: "#feature", label: "热议精选" },
  { href: "#digest", label: "群聊精华" },
  { href: "#faq", label: "帮助问答" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200 shadow-sm"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <nav className="h-16 md:h-[72px] flex items-center justify-between gap-4">
          <a href="#home" className="flex items-center gap-2 whitespace-nowrap" aria-label="吃瓜17社区 首页">
            <span className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center text-background-50 text-lg">
              <i className="ri-group-line" aria-hidden="true"></i>
            </span>
            <span className="font-logo text-2xl text-primary-600 leading-none">
              吃瓜<span className="text-foreground-950">17</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="px-3 py-2 rounded-full text-sm font-medium text-foreground-600 hover:text-primary-600 hover:bg-primary-100/70 transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <label className="relative">
              <span className="sr-only">搜索吃瓜17话题</span>
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" aria-hidden="true"></i>
              <input
                type="search"
                placeholder="搜帖子、搜话题"
                className="w-44 xl:w-56 h-10 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition"
              />
            </label>
            <a
              href="#join"
              className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold whitespace-nowrap transition-colors"
            >
              <i className="ri-pencil-fill text-sm" aria-hidden="true"></i>发帖
            </a>
            <a
              href="#join"
              className="px-4 py-2 rounded-full border border-foreground-200 text-foreground-700 hover:bg-foreground-50 text-sm font-medium whitespace-nowrap transition-colors"
            >
              登录
            </a>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center text-foreground-700"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </nav>

        {open && (
          <div className="lg:hidden pb-4 grid gap-1 md:hidden">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-100/70 hover:text-primary-600 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <div className="flex items-center gap-2 pt-2">
              <a
                href="#join"
                onClick={() => setOpen(false)}
                className="flex-1 text-center px-4 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap"
              >
                发帖
              </a>
              <a
                href="#join"
                onClick={() => setOpen(false)}
                className="flex-1 text-center px-4 py-2.5 rounded-full border border-foreground-200 text-foreground-700 text-sm font-medium whitespace-nowrap"
              >
                登录
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}